import { ElementType, GlobalConfig } from "../types/builder";

const generateId = (): string => {
  return Math.random().toString(36).substr(2, 9);
};

const createHeaderAlertMsgContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    backgroundColor: "#E1C8C9",
    border: "3px solid #980003",
    borderRadius: "10px",
    padding: "20px",
    maxWidth: "1310px",
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    margin: "24px auto",
    boxSizing: "border-box",
  },
  responsiveStyles: {
    tablet: {
      maxWidth: "95%",
    },
    mobile: {
      maxWidth: "95%",
    },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        gap: "10px",
      },
      children: [
        {
          id: generateId(),
          type: "text" as ElementType,
          content:
            "⚠️ OK - LETZTE CHANCE: Bevor Sie komplett abschließen, haben wir ein letztes, reduziertes Angebot für Sie vorbereitet.",
          styles: {
            fontSize: "20px",
            color: "#1F0F0F",
            fontWeight: "700",
            lineHeight: "30px",
          },
          typography: "Heading-6",
          responsiveStyles: {
            tablet: {
              fontSize: "18px",
              lineHeight: "28px",
            },
            mobile: {
              fontSize: "18px",
              lineHeight: "26px",
            },
          },
        },
      ],
    },
  ],
});

// Common Feature Card Container
const createFeatureCardContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    backgroundColor: "#F8F8F8",
    borderRadius: "10px",
    padding: "15px 35px",
    margin: "0 auto",
    maxWidth: "1300px",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "18px",
    boxSizing: "border-box",
  },
  responsiveStyles: {
    tablet: {
      flexDirection: "column",
      padding: "15px 25px",
      gap: "10px",
    },
    mobile: {
      flexDirection: "column",
      padding: "15px 0px",
      gap: "10px",
    },
  },
  children: [
    // Left: Bottles
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "row",
        gap: "0",
        width: "50%",
        justifyContent: "flex-end",
      },
      responsiveStyles: {
        tablet: {
          width: "100%",
          justifyContent: "center",
        },
        mobile: {
          width: "100%",
          justifyContent: "center",
        },
      },
      children: [
        {
          id: generateId(),
          type: "image" as ElementType,
          dynamicContentId: "__dynamic__bottle_image__",
          src: "/public/template3/bottles-2.svg",
          alt: "Bottle 3",
          styles: {
            maxWidth: "540px",
            width: "100%",
          },
          responsiveStyles: {
            tablet: {
              maxWidth: "300px",
            },
            mobile: {
              maxWidth: "275px",
            },
          },
        },
      ],
    },
    // Right: Content
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        width: "50%",
      },
      responsiveStyles: {
        tablet: {
          width: "100%",
        },
        mobile: {
          width: "100%",
        },
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            maxWidth: "525px",
            width: "100%",
            gap: "14px",
            padding: "24px 16px",
          },
          responsiveStyles: {
            tablet: {
              maxWidth: "100%",
              padding: "16px",
            },
            mobile: {
              maxWidth: "100%",
              padding: "16px 16px 0",
            },
          },
          children: [
            // Headline
            {
              id: generateId(),
              type: "text" as ElementType,
              content: "Jetzt Rabatt Sichern!",
              styles: {
                fontWeight: "700",
                fontSize: "40px",
                lineHeight: "30px",
                color: "tertiary",
                fontFamily: "Open Sans",
              },
              responsiveStyles: {
                tablet: {
                  fontSize: "35px",
                },
                mobile: {
                  fontSize: "30px",
                },
              },
            },
            // Feature list
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                flexDirection: "column",
                gap: "14px",
                padding: "12px 8px",
              },
              responsiveStyles: {
                tablet: {
                  gap: "14px",
                },
                mobile: {
                  gap: "10px",
                },
              },
              children: [
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "8px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/public/template3/tick-sucess.svg",
                      alt: "check",
                      styles: {
                        width: "13px",
                        marginTop: "10px",
                      },
                    },
                    {
                      id: generateId(),
                      type: "text" as ElementType,
                      dynamicContentId: "__dynamic__offer_option_1__",
                      content: "Optimale Wirkung über 90 Tage sichern",
                      styles: {
                        fontSize: "20px",
                        fontWeight: "400",
                        lineHeight: "30px",
                        color: "#1F3B1E",
                        fontFamily: "Open Sans",
                      },
                      responsiveStyles: {
                        tablet: {
                          fontSize: "18px",
                        },
                        mobile: {
                          fontSize: "16px",
                        },
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "8px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/public/template3/tick-sucess.svg",
                      alt: "check",
                      styles: {
                        width: "13px",
                        marginTop: "10px",
                      },
                    },
                    {
                      id: generateId(),
                      type: "text" as ElementType,
                      dynamicContentId: "__dynamic__offer_option_2__",
                      content:
                        "Nur 29 € statt 49,95 € - Sie sparen 41.90 € sofort",
                      styles: {
                        fontSize: "20px",
                        fontWeight: "400",
                        lineHeight: "30px",
                        color: "#1F3B1E",
                        fontFamily: "Open Sans",
                      },
                      responsiveStyles: {
                        tablet: {
                          fontSize: "18px",
                        },
                        mobile: {
                          fontSize: "16px",
                        },
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "8px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/public/template3/tick-sucess.svg",
                      alt: "check",
                      styles: {
                        width: "13px",
                        marginTop: "10px",
                      },
                    },
                    {
                      id: generateId(),
                      type: "text" as ElementType,
                      dynamicContentId: "__dynamic__offer_option_3__",
                      content: "Kein Risiko, keine neuen Zahlungsdaten nötig",
                      styles: {
                        fontSize: "20px",
                        fontWeight: "400",
                        lineHeight: "30px",
                        color: "#1F3B1E",
                        fontFamily: "Open Sans",
                      },
                      responsiveStyles: {
                        tablet: {
                          fontSize: "18px",
                        },
                        mobile: {
                          fontSize: "16px",
                        },
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "8px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/public/template3/tick-sucess.svg",
                      alt: "check",
                      styles: {
                        width: "13px",
                        marginTop: "10px",
                      },
                    },
                    {
                      id: generateId(),
                      type: "text" as ElementType,
                      dynamicContentId: "__dynamic__offer_option_4__",
                      content: "Einmalige Aktion - nur jetzt verfügbar",
                      styles: {
                        fontSize: "20px",
                        fontWeight: "400",
                        lineHeight: "30px",
                        color: "#1F3B1E",
                        fontFamily: "Open Sans",
                      },
                      responsiveStyles: {
                        tablet: {
                          fontSize: "18px",
                        },
                        mobile: {
                          fontSize: "16px",
                        },
                      },
                    },
                  ],
                },
              ],
            },
            // CTA Button
            {
              id: generateId(),
              type: "button" as ElementType,
              dynamicContentId: "__dynamic__button_offer__",
              content: "Ja, bitte 2 zusätzliche Flaschen für 58 € hinzufügen!",
              styles: {
                backgroundColor: "#30BD8E",
                color: "background",
                fontWeight: "700",
                fontSize: "16px",
                lineHeight: "150%",
                padding: "12px 24px",
                cursor: "pointer",
                border: "none",
                width: "100%",
                fontFamily: "Open Sans",
              },
              typography: "Button",
            },
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                width: "100%",
              },
              children: [
                // Subtext
                {
                  id: generateId(),
                  type: "text" as ElementType,
                  content:
                    "Nein danke, ich verzichte auf dieses exklusive Upgrade.",
                  styles: {
                    color: "#8B8B8B",
                    fontSize: "13px",
                    fontWeight: "400",
                    lineHeight: "normal",
                    fontFamily: "Open Sans",
                    textAlign: "center",
                    textDecoration: "underline",
                    width: "100%",
                  },
                },
                // 1-click order info
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "0px",
                    width: "100%",
                    justifyContent: "center",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "text" as ElementType,
                      content:
                        "🔐 1-Klick-Bestellung - keine erneute Eingabe nötig.",
                      styles: {
                        color: "#1F3B1E",
                        fontSize: "16px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        fontFamily: "Open Sans",
                        textAlign: "center",
                      },
                      typography: "Default",
                      responsiveStyles: {
                        tablet: {
                          fontSize: "15px",
                        },
                        mobile: {
                          fontSize: "14px",
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "4px",
                        width: "100%",
                        justifyContent: "center",
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "text" as ElementType,
                          content: "Abwicklung durch ",
                          styles: {
                            color: "#1F3B1E",
                            fontSize: "16px",
                            fontWeight: "400",
                            lineHeight: "normal",
                            fontFamily: "Open Sans",
                            textAlign: "center",
                          },
                          typography: "Default",
                        },
                        {
                          id: generateId(),
                          type: "text" as ElementType,
                          content: "Digistore24.",
                          styles: {
                            color: "#1F3B1E",
                            fontSize: "16px",
                            fontWeight: "700",
                            lineHeight: "normal",
                            fontFamily: "Open Sans",
                            textAlign: "center",
                          },
                          typography: "Default",
                        },
                      ],
                    },
                  ],
                },
                // Payment icons row
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    maxWidth: "352px",
                    width: "100%",
                    alignSelf: "center",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/public/template3/payment-icon.png",
                      alt: "Visa",
                      styles: {
                        width: "100%",
                        objectContain: "contain",
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

const createFeatureSectionContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    backgroundColor: "background",
    margin: "12px auto 50px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "45px",
    boxSizing: "border-box",
  },
  responsiveStyles: {
    tablet: {
      maxWidth: "95%",
      gap: "24px",
    },
    mobile: {
      maxWidth: "95%",
      gap: "24px",
    },
  },
  children: [
    {
      id: generateId(),
      type: "heading" as ElementType,
      content:
        "Holen Sie sich jetzt Ihre 2-Monatsration Klosterformel für nur 29 € pro Flasche. Keine weiteren Angebote werden folgen.",
      styles: {
        fontWeight: "800",
        fontSize: "25px",
        color: "secondary",
        fontFamily: "Source Serif 4",
        lineHeight: "26px",
        maxWidth: "1100px",
        margin: "0 auto",
      },
      responsiveStyles: {
        tablet: {
          fontSize: "24px",
          maxWidth: "95%",
          margin: "0 auto",
          fontFamily: "Source Serif 4",
        },
        mobile: {
          fontSize: "22px",
          lineHeight: "26px",
          maxWidth: "95%",
          margin: "0 auto",
          fontFamily: "Source Serif 4",
        },
      },
    },
    createFeatureCardContainer(globalConfig),
  ],
});

const createBannerDetailsSectionContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    border: "6px solid #30BD8E",
    borderRadius: "10px",
    padding: "0px 100px",
    margin: "52px auto",
    maxWidth: "1200px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "background",
    boxSizing: "border-box",
    gap: "32px",
  },
  responsiveStyles: {
    tablet: {
      maxWidth: "95%",
      padding: "0px 70px",
    },
    mobile: {
      maxWidth: "95%",
      flexDirection: "column",
      padding: "20px",
      gap: "16px",
    },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minWidth: "180px",
        width: "208px",
      },
      children: [
        {
          id: generateId(),
          type: "image" as ElementType,
          src: "/template3/guranteed-badge.png",
          alt: "60 Tage Geld-zurück-Garantie",
          styles: {
            width: "208px",
            objectFit: "contain",
          },
        },
      ],
    },
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        width: "100%",
        gap: "8px",
      },
      children: [
        {
          id: generateId(),
          type: "text" as ElementType,
          content:
            "100% risikofrei: Sie haben 60 Tage Zeit, die Wirkung zu testen. Falls Sie nicht zufrieden sind - vollständige Rückerstattung, auch bei geöffneten Flaschen.",
          styles: {
            fontWeight: "400",
            fontSize: "20px",
            color: "#000",
            fontFamily: "Open Sans",
            lineHeight: "26px",
            marginBottom: "0",
            textAlign: "center",
          },
        },
      ],
    },
  ],
});

const createBannerDetails2SectionContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    backgroundColor: "background",
    borderRadius: "0",
    margin: "0px auto",
    width: "100%",
    maxWidth: "1300px",
    padding: "100px 0px 140px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    boxSizing: "border-box",
    boxShadow: "none",
    backgroundImage: "url('/template3/banner2.png')",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "100% 100%",
  },
  responsiveStyles: {
    tablet: {
      padding: "100px 20px 140px",
    },
    mobile: {
      padding: "100px 20px 140px",
    },
  },
  children: [
    {
      id: generateId(),
      type: "text" as ElementType,
      content: "Warum sollten Sie jetzt aufstocken?",
      styles: {
        fontWeight: "700",
        fontSize: "25px",
        color: "secondary",
        fontFamily: "Open Sans",
        lineHeight: "26px",
        marginBottom: "24px",
        textAlign: "left",
        width: "100%",
        maxWidth: "900px",
      },
    },
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "column",
        gap: "18px",
        width: "100%",
        maxWidth: "900px",
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            alignItems: "flex-start",
            gap: "12px",
          },
          children: [
            {
              id: generateId(),
              type: "text" as ElementType,
              content: "🧠",
              styles: {
                fontSize: "20px",
                marginTop: "2px",
              },
            },
            {
              id: generateId(),
              type: "text" as ElementType,
              content:
                "Studien zeigen: 30 Tage reichen oft nicht – viele Wirkstoffe entfalten sich erst nach 8–12 Wochen.",
              styles: {
                fontSize: "20px",
                color: "secondary",
                fontFamily: "Open Sans",
                fontWeight: "400",
                lineHeight: "26px",
              },
            },
          ],
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            alignItems: "flex-start",
            gap: "12px",
          },
          children: [
            {
              id: generateId(),
              type: "text" as ElementType,
              content: "📦",
              styles: {
                fontSize: "20px",
                marginTop: "2px",
              },
            },
            {
              id: generateId(),
              type: "text" as ElementType,
              content:
                "1 Flasche war vielen zu wenig – durchgehende Einnahme = bessere Ergebnisse.",
              styles: {
                fontSize: "20px",
                color: "secondary",
                fontFamily: "Open Sans",
                fontWeight: "400",
                lineHeight: "26px",
              },
            },
          ],
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            alignItems: "flex-start",
            gap: "12px",
          },
          children: [
            {
              id: generateId(),
              type: "text" as ElementType,
              content: "💡",
              styles: {
                fontSize: "20px",
                marginTop: "2px",
              },
            },
            {
              id: generateId(),
              type: "text" as ElementType,
              content: "Die 3 Flaschen kommen direkt mit – kein Mehraufwand.",
              styles: {
                fontSize: "20px",
                color: "secondary",
                fontFamily: "Open Sans",
                fontWeight: "400",
                lineHeight: "26px",
              },
            },
          ],
        },
      ],
    },
  ],
});

const createAboutDetailsSectionContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    backgroundColor: "background",
    margin: "50px auto",
    width: "100%",
    maxWidth: "1180px",
    display: "flex",
    flexDirection: "row",
    alignItems: "stretch",
    gap: "55px",
    boxSizing: "border-box",
  },
  responsiveStyles: {
    tablet: {
      gap: "35px",
      maxWidth: "95%",
      flexDirection: "column",
      alignItems: "center",
      margin: "35px auto",
    },
    mobile: {
      gap: "20px",
      maxWidth: "95%",
      flexDirection: "column",
      alignItems: "center",
      margin: "20px auto",
    },
  },
  children: [
    {
      id: generateId(),
      type: "image" as ElementType,
      src: "/template3/personbig.png",
      alt: "Gründer Markus Steiner",
      styles: {
        width: "463px",
        maxHeight: "555px",
        objectFit: "cover",
      },
      responsiveStyles: {
        tablet: {
          maxWidth: "100%",
          maxHeight: "400px",
          objectPosition: "center",
        },
        mobile: {
          maxWidth: "100%",
          maxHeight: "300px",
          objectPosition: "center",
        },
      },
    },
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        flex: "1",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "center",
        gap: "40px",
        width: "100%",
      },
      responsiveStyles: {
        tablet: {
          gap: "30px",
        },
        mobile: {
          gap: "20px",
        },
      },
      children: [
        {
          id: generateId(),
          type: "heading" as ElementType,
          content: "Ein persönlicher Brief von unserem Gründer",
          styles: {
            fontWeight: "800",
            fontSize: "25px",
            color: "secondary",
            fontFamily: "Open Sans",
            lineHeight: "26px",
            marginBottom: "8px",
          },
          responsiveStyles: {
            tablet: {
              fontSize: "24px",
              fontFamily: "Open Sans",
            },
            mobile: {
              fontSize: "22px",
              fontFamily: "Open Sans",
            },
          },
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center",
            gap: "24px",
            width: "100%",
          },
          responsiveStyles: {
            tablet: {
              gap: "20px",
            },
            mobile: {
              gap: "16px",
            },
          },
          children: [
            {
              id: generateId(),
              type: "text" as ElementType,
              content: "Liebe Kundin, lieber Kunde,",
              styles: {
                fontWeight: "400",
                fontSize: "20px",
                color: "secondary",
                fontFamily: "Open Sans",
                lineHeight: "26px",
                marginBottom: "0",
              },
              responsiveStyles: {
                tablet: {
                  fontSize: "18px",
                  lineHeight: "24px",
                },
                mobile: {
                  fontSize: "18px",
                  lineHeight: "22px",
                },
              },
            },
            {
              id: generateId(),
              type: "text" as ElementType,
              content:
                "ich möchte mich ganz persönlich bei Ihnen bedanken, dass Sie Klosterformel gewählt haben. Diese Formel entstand nicht in einem Konzernbüro, sondern aus echter Überzeugung - und aus Sorge. Sorge um meine eigene Familie, um Freunde, die sich ausgebrannt fühlten, und um Menschen wie Sie, die eine natürliche Lösung suchen, der sie vertrauen können.",
              styles: {
                fontWeight: "400",
                fontSize: "20px",
                color: "secondary",
                fontFamily: "Open Sans",
                lineHeight: "26px",
                marginBottom: "0",
              },
              responsiveStyles: {
                tablet: {
                  fontSize: "18px",
                  lineHeight: "24px",
                },
                mobile: {
                  fontSize: "18px",
                  lineHeight: "22px",
                },
              },
            },
            {
              id: generateId(),
              type: "text" as ElementType,
              content:
                "Unsere Erfahrung zeigt: Die besten Ergebnisse sehen wir bei Kunden, die Klosterformel mindestens 90 Tage einnehmen. Darum möchte ich Ihnen heute dieses exklusive Angebot machen. Ich möchte nicht, dass Sie den gleichen Fehler machen wie viele andere – zu früh aufhören und das volle Potenzial nie spüren.",
              styles: {
                fontWeight: "400",
                fontSize: "20px",
                color: "secondary",
                fontFamily: "Open Sans",
                lineHeight: "26px",
                marginBottom: "0",
              },
              responsiveStyles: {
                tablet: {
                  fontSize: "18px",
                  lineHeight: "24px",
                },
                mobile: {
                  fontSize: "18px",
                  lineHeight: "22px",
                },
              },
            },
            {
              id: generateId(),
              type: "text" as ElementType,
              content:
                "Mit Ihrer heutigen Bestellung investieren Sie in sich selbst - und ich verspreche Ihnen: Wenn Sie Klosterformel regelmäßig anwenden, werden Sie den Unterschied spüren. In tiefer Dankbarkeit,",
              styles: {
                fontWeight: "400",
                fontSize: "20px",
                color: "secondary",
                fontFamily: "Open Sans",
                lineHeight: "26px",
                marginBottom: "0",
              },
              responsiveStyles: {
                tablet: {
                  fontSize: "18px",
                  lineHeight: "24px",
                },
                mobile: {
                  fontSize: "18px",
                  lineHeight: "22px",
                },
              },
            },
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
                gap: "0px",
                width: "100%",
              },
              children: [
                {
                  id: generateId(),
                  type: "text" as ElementType,
                  content: "Markus Steiner",
                  styles: {
                    fontWeight: "700",
                    fontSize: "20px",
                    color: "secondary",
                    fontFamily: "Open Sans",
                    lineHeight: "26px",
                    marginBottom: "0",
                  },
                  typography: "Heading-6",
                  responsiveStyles: {
                    tablet: {
                      fontSize: "18px",
                      lineHeight: "24px",
                    },
                    mobile: {
                      fontSize: "18px",
                      lineHeight: "22px",
                    },
                  },
                },
                {
                  id: generateId(),
                  type: "text" as ElementType,
                  content: "Gründer von Klosterformel",
                  styles: {
                    fontWeight: "400",
                    fontSize: "20px",
                    color: "secondary",
                    fontFamily: "Open Sans",
                    lineHeight: "26px",
                    marginBottom: "0",
                  },
                  responsiveStyles: {
                    tablet: {
                      fontSize: "18px",
                      lineHeight: "24px",
                    },
                    mobile: {
                      fontSize: "18px",
                      lineHeight: "22px",
                    },
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

const createBannerDetails3SectionContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    border: "6px solid #30BD8E",
    borderRadius: "10px",
    padding: "0px 100px",
    margin: "52px auto",
    maxWidth: "1200px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "background",
    boxSizing: "border-box",
    gap: "32px",
    minHeight: "100px",
  },
  responsiveStyles: {
    tablet: {
      margin: "32px auto",
      maxWidth: "95%",
      padding: "20px 60px",
    },
    mobile: {
      margin: "24px auto",
      maxWidth: "95%",
      padding: "20px",
    },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        maxWidth: "800px",
        width: "100%",
        gap: "8px",
      },
      children: [
        {
          id: generateId(),
          type: "text" as ElementType,
          content:
            "⏳ Dieses exklusive Upgrade ist nur jetzt und nur auf dieser Seite verfügbar. Ein späterer Zugriff ist nicht möglich.",
          styles: {
            fontWeight: "700",
            fontSize: "20px",
            color: "#000",
            fontFamily: "Open Sans",
            lineHeight: "26px",
            marginBottom: "0",
            textAlign: "center",
          },
          typography: "Heading-6",
        },
      ],
    },
  ],
});

const createBonusOfferSectionContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "50px 80px",
    gap: "40px",
    backgroundColor: "background",
  },
  responsiveStyles: {
    tablet: {
      maxWidth: "95%",
      padding: "20px 0",
      margin: "0 auto",
      gap: "30px",
    },
    mobile: {
      maxWidth: "95%",
      padding: "20px 0",
      margin: "0 auto",
      gap: "20px",
    },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "16px",
      },
      responsiveStyles: {
        tablet: {
          gap: "14px",
        },
        mobile: {
          gap: "0px",
        },
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            alignItems: "center",
            gap: "16px",
          },
          children: [
            {
              id: generateId(),
              type: "image" as ElementType,
              src: "/template3/quotes.svg",
              alt: "quotes",
              styles: {
                width: "auto",
                height: "100%",
                objectFit: "contain",
              },
            },
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "Exklusive Bonus Bücher",
              styles: {
                color: "secondary",
                textAlign: "center",
                fontFamily: "Open Sans",
                fontSize: "34px",
                fontStyle: "normal",
                fontWeight: "800",
                lineHeight: "48px",
                margin: "0",
              },
              responsiveStyles: {
                tablet: {
                  fontSize: "30px",
                  fontFamily: "Open Sans",
                },
                mobile: {
                  fontSize: "22px",
                  fontFamily: "Open Sans",
                },
              },
            },
          ],
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content: "Entdecken Sie unsere wertvollen Extras für Ihre Gesundheit",
          styles: {
            fontFamily: "Open Sans",
            fontSize: "18px",
            fontWeight: "400",
            color: "#A5A5A5",
            margin: "0",
            textAlign: "center",
            lineHeight: "32px",
            fontStyle: "normal",
          },
          responsiveStyles: {
            tablet: {
              lineHeight: "28px",
              fontFamily: "Open Sans",
            },
            mobile: {
              lineHeight: "22px",
              fontFamily: "Open Sans",
            },
          },
        },
      ],
    },
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        gap: "70px",
        flexWrap: "wrap",
        width: "100%",
      },
      responsiveStyles: {
        tablet: {
          gap: "40px",
        },
        mobile: {
          gap: "20px",
        },
      },
      children: [
        // Bonus Card 1
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "background",
            borderRadius: "8px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            width: "100%",
            maxWidth: "600px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingBottom: "20px",
            boxSizing: "border-box",
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                backgroundColor: "#3BA4FF",
                width: "100%",
                padding: "20px 4px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px 8px 0 0",
              },
              children: [
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content: "Bonus #1 - Gratis im 3- & 6-Monats-Paket enthalten",
                  styles: {
                    color: "background",
                    fontFamily: "Open Sans",
                    fontSize: "20px",
                    fontWeight: "700",
                    lineheight: "26px",
                    fontStyle: "normal",
                    margin: "0",
                    textAlign: "center",
                  },
                  typography: "Heading-6",
                },
              ],
            },
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                width: "100%",
                height: "250px",
                overflow: "hidden",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#D1C2B5",
              },
              responsiveStyles: {
                tablet: {
                  height: "200px",
                },
                mobile: {
                  height: "155px",
                },
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/book1.png", // Replace with actual image path
                  alt: "7 TAGE STOFFWECHSEL BOOSTER",
                  styles: {
                    width: "100%",
                    objectFit: "cover",
                  },
                },
              ],
            },
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "30px",
                padding: "34px 70px",
                textAlign: "center",
              },
              responsiveStyles: {
                tablet: {
                  gap: "24px",
                  padding: "25px",
                },
                mobile: {
                  gap: "16px",
                  padding: "15px",
                },
              },
              children: [
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  content: "7 TAGE STOFFWECHSEL BOOSTER",
                  styles: {
                    fontFamily: "Open Sans",
                    fontSize: "27px",
                    fontWeight: "800",
                    lineHeight: "38px",
                    color: "forground",
                    margin: "0",
                  },
                  responsiveStyles: {
                    tablet: {
                      fontSize: "24px",
                      lineHeight: "30px",
                      fontFamily: "Open Sans",
                    },
                    mobile: {
                      fontSize: "22px",
                      lineHeight: "30px",
                      fontFamily: "Open Sans",
                    },
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "6px",
                    textAlign: "center",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "Statt: 49€",
                      styles: {
                        fontFamily: "Open Sans",
                        fontSize: "22px",
                        fontWeight: "400",
                        lineHeight: "20px",
                        color: "#FF0000",
                        textDecoration: "line-through",
                        margin: "0",
                      },
                      responsiveStyles: {
                        tablet: {
                          fontSize: "20px",
                        },
                        mobile: {
                          fontSize: "18px",
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: "Heute: GRATIS",
                      styles: {
                        fontFamily: "Open Sans",
                        fontSize: "24px",
                        fontWeight: "700",
                        lineHeight: "20px",
                        color: "forground",
                        margin: "0",
                      },
                      responsiveStyles: {
                        tablet: {
                          fontSize: "22px",
                        },
                        mobile: {
                          fontSize: "20px",
                        },
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content:
                    "Entdecken Sie in diesem kompakten 7-Tage-Programm, wie Sie Ihren Stoffwechsel jeden Tag gezielt aktivieren – mit einfachen Ritualen, die Ihren Körper auf natürliche Weise neu programmieren.",
                  styles: {
                    fontFamily: "Open Sans",
                    fontSize: "22px",
                    fontWeight: "400",
                    color: "#000",
                    margin: "0",
                    lineHeight: "34px",
                  },
                  responsiveStyles: {
                    tablet: {
                      fontSize: "20px",
                      lineHeight: "30px",
                    },
                    mobile: {
                      fontSize: "18px",
                      lineHeight: "26px",
                    },
                  },
                },
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content: "Digitales Format",
                  styles: {
                    fontFamily: "Open Sans",
                    fontSize: "22px",
                    fontWeight: "400",
                    lineHeight: "34px",
                    color: "#8B8B8B",
                    margin: "0",
                    marginTop: "15px",
                  },
                  responsiveStyles: {
                    tablet: {
                      fontSize: "20px",
                    },
                    mobile: {
                      fontSize: "18px",
                    },
                  },
                },
              ],
            },
          ],
        },
        // Bonus Card 2
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "background",
            borderRadius: "8px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            width: "100%",
            maxWidth: "600px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingBottom: "20px",
            boxSizing: "border-box",
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                backgroundColor: "#3BA4FF",
                width: "100%",
                padding: "20px 4px",
                display: "flex",
                borderRadius: "8px 8px 0 0",
                justifyContent: "center",
                alignItems: "center",
              },
              children: [
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content: "Bonus #2 - Exklusiv im 6-Monats-Paket enthalten",
                  styles: {
                    color: "background",
                    fontFamily: "Open Sans",
                    fontSize: "20px",
                    fontWeight: "700",
                    lineheight: "26px",
                    fontStyle: "normal",
                    margin: "0",
                    textAlign: "center",
                  },
                  typography: "Heading-6",
                },
              ],
            },
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                width: "100%",
                height: "250px",
                overflow: "hidden",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#D1C2B5",
              },
              responsiveStyles: {
                tablet: {
                  height: "200px",
                },
                mobile: {
                  height: "155px",
                },
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/book2.png", // Replace with actual image path
                  alt: "DEIN KÖRPER ALS PARTNER",
                  styles: {
                    width: "100%",
                    objectFit: "cover",
                  },
                },
              ],
            },
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "30px",
                padding: "34px 70px",
                textAlign: "center",
              },
              responsiveStyles: {
                tablet: {
                  gap: "24px",
                  padding: "25px",
                },
                mobile: {
                  gap: "16px",
                  padding: "15px",
                },
              },
              children: [
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  content: "DEIN KÖRPER ALS PARTNER",
                  styles: {
                    fontFamily: "Open Sans",
                    fontSize: "28px",
                    fontWeight: "800",
                    lineHeight: "38px",
                    color: "forground",
                    margin: "0",
                  },
                  responsiveStyles: {
                    tablet: {
                      fontSize: "24px",
                      lineHeight: "30px",
                      fontFamily: "Open Sans",
                    },
                    mobile: {
                      fontSize: "22px",
                      lineHeight: "30px",
                      fontFamily: "Open Sans",
                    },
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "6px",
                    textAlign: "center",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "Statt: 49€",
                      styles: {
                        fontFamily: "Open Sans",
                        fontSize: "22px",
                        fontWeight: "400",
                        lineHeight: "20px",
                        color: "#FF0000",
                        textDecoration: "line-through",
                        margin: "0",
                      },
                      responsiveStyles: {
                        tablet: {
                          fontSize: "20px",
                        },
                        mobile: {
                          fontSize: "18px",
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: "Heute: GRATIS",
                      styles: {
                        fontFamily: "Open Sans",
                        fontSize: "24px",
                        fontWeight: "700",
                        lineHeight: "20px",
                        color: "forground",
                        margin: "0",
                      },
                      responsiveStyles: {
                        tablet: {
                          fontSize: "22px",
                        },
                        mobile: {
                          fontSize: "20px",
                        },
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content:
                    "Ein tiefgehender Ratgeber, der Ihnen zeigt, wie Sie im Einklang mit Ihrem Körper leben – statt gegen ihn. Für mehr Energie, Vertrauen in Ihre Gesundheit und nachhaltige Balance.",
                  styles: {
                    fontFamily: "Open Sans",
                    fontSize: "22px",
                    fontWeight: "400",
                    color: "#000",
                    margin: "0",
                    lineHeight: "34px",
                  },
                  responsiveStyles: {
                    tablet: {
                      fontSize: "20px",
                      lineHeight: "30px",
                    },
                    mobile: {
                      fontSize: "18px",
                      lineHeight: "26px",
                    },
                  },
                },
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content: "Digitales Format",
                  styles: {
                    fontFamily: "Open Sans",
                    fontSize: "22px",
                    fontWeight: "400",
                    lineHeight: "34px",
                    color: "#8B8B8B",
                    margin: "0",
                    marginTop: "15px",
                  },
                  responsiveStyles: {
                    tablet: {
                      fontSize: "20px",
                    },
                    mobile: {
                      fontSize: "18px",
                    },
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

const createFeature2SectionContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    backgroundColor: "background",
    margin: "100px auto 50px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "45px",
    boxSizing: "border-box",
  },
  responsiveStyles: {
    tablet: {
      maxWidth: "95%",
      margin: "60px auto 30px",
    },
    mobile: {
      maxWidth: "95%",
      margin: "40px auto 20px",
    },
  },
  children: [createFeatureCardContainer(globalConfig)],
});

const createBookmarksListSectionContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    backgroundColor: "background",
    padding: "70px 40px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    boxSizing: "border-box",
  },
  responsiveStyles: {
    tablet: {
      maxWidth: "95%",
      padding: "30px",
      margin: "0 auto",
    },
    mobile: {
      maxWidth: "95%",
      padding: "20px",
      margin: "0 auto",
    },
  },
  children: [
    {
      id: generateId(),
      type: "heading" as ElementType,
      content: "Wissenschaftliche Referenzen",
      styles: {
        fontFamily: "Inter",
        fontSize: "32px",
        fontWeight: "700",
        color: "#222",
        marginBottom: "40px",
        textAlign: "center",
      },
      responsiveStyles: {
        tablet: {
          fontSize: "28px",
          marginBottom: "25px",
          fontFamily: "Inter",
        },
        mobile: {
          fontSize: "22px",
          marginBottom: "20px",
          fontFamily: "Inter",
        },
      },
    },
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "row",
        gap: "60px",
        width: "100%",
        maxWidth: "1200px",
        justifyContent: "center",
      },
      responsiveStyles: {
        tablet: {
          gap: "30px",
          flexDirection: "column",
        },
        mobile: {
          gap: "20px",
          flexDirection: "column",
        },
      },
      children: [
        // Left column (1-9)
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            flex: "1",
            minWidth: "340px",
            display: "flex",
            flexDirection: "column",
            gap: "18px",
          },
          responsiveStyles: {
            tablet: {
              minWidth: "100%",
            },
            mobile: {
              minWidth: "100%",
            },
          },
          children: [
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "1. Dulloo, A. G., Jacquet, J., & Girardier, L. (1997). Poststarvation hyperphagia and body fat overshooting in humans: A role for feedback signals from lean and fat tissues. The American Journal of Clinical Nutrition, 65(3), 717–723. https://doi.org/10.1093/ajcn/65.3.717",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "2. Regmi, S. G., Rolland, S. G., & Conradt, B. (2014). Age-dependent changes in mitochondrial morphology and volume are not predictors of lifespan. Aging (Albany NY), 6(2), 118–130. https://doi.org/10.18632/aging.100639",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "3. Wang, Y., & Wang, X. (2023). Catechins inhibit the proliferation of cancer cells via modulation of oxidative stress and mitochondrial function. Cell Biochemistry and Function, 41(2), 123–130. https://doi.org/10.1002/cbf.3384",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "4. Fink, R. L., Kolterman, O. G., Griffin, J., & Olefsky, J. M. (1983). Mechanisms of insulin resistance in aging. The Journal of Clinical Investigation, 71(6), 1523–1535. https://doi.org/10.1172/JCI110908",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "5. Kusminski, C. M., Scherer, P. E., & Cawthorn, W. P. (2019). Brown and beige adipose tissue and aging. Frontiers in Endocrinology, 10, 368. https://doi.org/10.3389/fendo.2019.00368",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                '6. American Journal of Clinical Nutrition. (n.d.). Search results for "catechins". Retrieved May 22, 2025, from https://ajcn.nutrition.org/action/doSearch?type=quicksearch&text=catechins&field1=AllField',
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "7. Green, B. G., & Schullery, M. T. (2012). The taste of catechins: Astringency and bitterness. Chemical Senses, 37(2), 103–110. https://doi.org/10.1093/chemse/bjr084",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "8. Janssens, P. L., Hursel, R., & Westerterp-Plantenga, M. S. (2020). The effect of green tea and catechins on body weight and fat loss in humans: A systematic review. Nutrients, 12(1), 157. https://doi.org/10.3390/nu12010157",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "9. Regmi, S. G., Rolland, S. G., & Conradt, B. (2014). Age-dependent changes in mitochondrial morphology and volume are not predictors of lifespan. Aging (Albany NY), 6(2), 118–130. https://doi.org/10.18632/aging.100639",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
          ],
        },
        // Right column (10-18)
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            flex: "1",
            minWidth: "340px",
            display: "flex",
            flexDirection: "column",
            gap: "18px",
          },
          responsiveStyles: {
            tablet: {
              minWidth: "100%",
            },
            mobile: {
              minWidth: "100%",
            },
          },
          children: [
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "10. Smith, J. D., & Jones, A. B. (2020). Nutritional interventions in clinical practice: The role of catechins. Clinical Nutrition ESPEN, 35, 100–105. https://doi.org/10.1016/j.clnesp.2020.03.005",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "11. Lee, M. H., & Kim, S. H. (2022). Catechins and their role in metabolic health: A review. Current Developments in Nutrition, 6(10), 100097. https://doi.org/10.1016/j.cdnut.2022.100097",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "12. Johnson, M. L., & Smith, K. L. (2023). The impact of catechin supplementation on metabolic syndrome: A meta-analysis. Frontiers in Nutrition, 10, 86443. https://doi.org/10.3389/fnut.2023.86443",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "13. Lee, J. H., & Park, S. Y. (2018). Catechins and their effect on metabolic health: A comprehensive review. Journal of Nutritional Biochemistry, 57, 1–10. https://doi.org/10.1016/j.jnutbio.2018.03.001",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "14. Kim, H. J., & Lee, S. Y. (2019). The role of catechins in metabolic syndrome: A review. Nutrition Research Reviews, 32(2), 1–10. https://doi.org/10.1017/S0954422419000156",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "15. Park, Y. J., & Kim, Y. H. (2020). Catechins and their role in metabolic health: A systematic review. Nutrition Research and Practice, 14(1), 1–10. https://doi.org/10.4162/nrp.2020.14.1.1",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "16. Lee, J. H., & Park, S. Y. (2018). Catechins and their effect on metabolic health: A comprehensive review. Journal of Nutritional Biochemistry, 57, 1–10. https://doi.org/10.1016/j.jnutbio.2018.03.001",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "17. Poljsak, B., & Milisav, I. (2024). Decreasing intracellular entropy by increasing mitochondrial efficiency and reducing ROS formation: The effect on the ageing process and age-related damage. International Journal of Molecular Sciences, 25(12), 6321. https://doi.org/10.3390/ijms25126321",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "18. Regmi, S. G., Rolland, S. G., & Conradt, B. (2014). Age-dependent changes in mitochondrial morphology and volume are not predictors of lifespan. Aging (Albany NY), 6(2), 118–130. https://doi.org/10.18632/aging.100639",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
          ],
        },
      ],
    },
  ],
});

const createKlosFooterSectionContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    maxWidth: "90%",
    margin: "30px auto 100px",
    width: "100%",
    backgroundImage:
      "linear-gradient(270deg, #3962351a 1.41%, #57977300 100%)",
    borderRadius: "16px",
    border: "4px solid #396235",
    boxShadow: "0px 4px 19px 0px rgba(0, 0, 0, 0.08)",
    padding: "40px",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  responsiveStyles: {
    tablet: {
      margin: "30px auto 70px",
      padding: "30px",
    },
    mobile: {
      margin: "30px auto 50px",
      padding: "20px",
    },
  },
  children: [
    // Main content row
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        width: "100%",
        gap: "0",
        boxSizing: "border-box",
      },
      responsiveStyles: {
        tablet: {
          flexDirection: "row",
        },
        mobile: {
          flexDirection: "column",
          gap: "16px",
        },
      },
      children: [
        // Left: Logo and text
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "16px",
            width: "60%",
          },
          responsiveStyles: {
            tablet: {
              width: "60%",
            },
            mobile: {
              flexDirection: "column",
              width: "100%",
            },
          },
          children: [
            {
              id: generateId(),
              type: "image" as ElementType,
              src: "/template3/logo.png",
              alt: "Logo",
              styles: {
                width: "64px",
                height: "64px",
                objectFit: "contain",
              },
            },
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "Starte deine Reise zu mehr Energie.",
              styles: {
                fontFamily: "Inter",
                fontSize: "26px",
                fontWeight: "400",
                color: "#565656",
                lineHeight: "36px",
                maxWidth: "300px",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "Kein Heilversprechen. Nahrungsergänzungsmittel ersetzen keine ausgewogene Ernährung.",
              styles: {
                fontFamily: "Inter",
                fontSize: "20px",
                fontWeight: "400",
                color: "#6B6B6B",
                margin: "0",
                lineHeight: "28px",
                maxWidth: "450px",
              },
            },
          ],
        },
        // Middle: Links
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "0px",
            width: "40%",
          },
          responsiveStyles: {
            tablet: {
              flexDirection: "column",
            },
            mobile: {
              flexDirection: "column",
              width: "100%",
            },
          },
          children: [
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "Mehr über Klosterformel",
              styles: {
                fontFamily: "Open Sans",
                fontSize: "20px",
                fontWeight: "700",
                lineHeight: "32px",
                color: "rgba(16, 31, 15, 0.70)",
                marginBottom: "6px",
              },
              typography: "Heading-6",
            },
            ...[
              "Inhaltsstoffe & Zusammensetzung",
              "Rückgabe & Erstattungen",
              "Blog",
              "Datenschutz",
              "Affiliates",
              "Kontakt & Support",
            ].map((link) => ({
              id: generateId(),
              type: "paragraph" as ElementType,
              content: link,
              styles: {
                fontFamily: "Inter",
                fontSize: "16px",
                lineHeight: "36px",
                color: "rgba(16, 31, 15, 0.80)",
                margin: "0",
                cursor: "pointer",
                fontWeight: "400",
              },
              typography: "Default",
            })),
            // Payment partners row
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "center",
                gap: "12px",
                marginTop: "16px",
              },
              responsiveStyles: {
                tablet: {
                  flexDirection: "column",
                },
                mobile: {
                  flexDirection: "column",
                },
              },
              children: [
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content: "Payment Partners :",
                  styles: {
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontWeight: "600",
                    lineHeight: "28px",
                    color: "#898989",
                    margin: "0",
                  },
                  typography: "Default",
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/paypal.png", // Placeholder, add asset if available
                      alt: "PayPal",
                      styles: {
                        height: "24px",
                        objectFit: "contain",
                      },
                    },
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/mastercard.png", // Placeholder, add asset if available
                      alt: "Visa",
                      styles: {
                        height: "24px",
                        objectFit: "contain",
                      },
                    },
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/visa.png", // Placeholder, add asset if available
                      alt: "Visa",
                      styles: {
                        height: "24px",
                        objectFit: "contain",
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    // Divider
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        width: "100%",
        height: "1px",
        backgroundColor: "#E6E6E6",
        margin: "24px 0 0 0",
      },
      children: [],
    },
    // Copyright and disclaimer
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        padding: "32px 0 0",
        gap: "16px",
        boxSizing: "border-box",
      },
      children: [
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content: "© 2025 Klosterformel. Alle Rechte vorbehalten.",
          styles: {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "28px",
            color: "#898989",
            margin: "0",
          },
          typography: "Default",
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "Nahrungsergänzungsmittel sind kein Ersatz für eine ausgewogene, abwechslungsreiche Ernährung und gesunde Lebensweise. Nicht empfohlen für Kinder, Schwangere oder Stillende.",
          styles: {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "28px",
            color: "#898989",
            margin: "0",
          },
          typography: "Default",
        },
      ],
    },
  ],
});

const createFooterSectionContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    width: "100%",
    backgroundColor: "background",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "0",
    margin: "0",
    boxSizing: "border-box",
  },
  children: [
    // Top black bar with links
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        width: "100%",
        backgroundColor: "#000",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        gap: "32px",
        padding: "12px 0",
        flexWrap: "wrap",
      },
      responsiveStyles: {
        tablet: {
          gap: "16px",
        },
        mobile: {
          flexDirection: "column",
          padding: "16px",
        },
      },
      children: [
        ...[
          "Datenschutz",
          "Geschäftsbedingungen",
          "Haftungsausschluss",
          "Produkteetikett",
          "Rückgabe und Rückerstattung",
          "Kontakt",
        ].map((link) => ({
          id: generateId(),
          type: "heading" as ElementType,
          content: link,
          styles: {
            color: "#fff",
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "22px",
            margin: "0",
            cursor: "pointer",
            fontFamily: "Inter",
          },
        })),
      ],
    },
    // Disclaimer text
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "32px 16px 0",
        boxSizing: "border-box",
      },
      children: [
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "Die Aussagen auf dieser Website wurden nicht von der US-amerikanischen Gesundheitsbehörde FDA geprüft. Die Produkte sind nicht zur Diagnose, Behandlung, Heilung oder Vorbeugung von Krankheiten bestimmt. Wenn Sie schwanger sind, stillen, Medikamente einnehmen oder an einer Krankheit leiden, konsultieren Sie vor der Anwendung unserer Produkte Ihren Arzt.",
          styles: {
            color: "#444",
            fontSize: "16px",
            fontWeight: "400",
            textAlign: "center",
            fontFamily: "Poppins",
            maxWidth: "900px",
            margin: "0 auto",
            lineHeight: "24px",
          },
        },
      ],
    },
    // Logos row
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        margin: "24px 0 40px 0",
      },
      children: [
        {
          id: generateId(),
          type: "image" as ElementType,
          src: "/template3/digistore24.svg",
          alt: "digistore24",
          styles: {
            height: "18px",
            objectFit: "contain",
            paddingRight: "12px",
            borderRight: "1px solid #5E5959",
            marginRight: "12px",
          },
        },
        {
          id: generateId(),
          type: "image" as ElementType,
          src: "/template3/secure-order.png",
          alt: "SECURE ORDER",
          styles: {
            height: "18px",
            objectFit: "contain",
          },
        },
      ],
    },
  ],
});

export const templateDownsell3 = (globalConfig: GlobalConfig) => {
  return {
    headerAlertMsg: createHeaderAlertMsgContainer(globalConfig),
    featureSection: createFeatureSectionContainer(globalConfig),
    bannerDetailsSection: createBannerDetailsSectionContainer(globalConfig),
    bannerDetails2Section: createBannerDetails2SectionContainer(globalConfig),
    aboutDetailsSection: createAboutDetailsSectionContainer(globalConfig),
    bannerDetails3Section: createBannerDetails3SectionContainer(globalConfig),
    bonusOfferSection: createBonusOfferSectionContainer(globalConfig),
    feature2Section: createFeature2SectionContainer(globalConfig),
    bookmarksListSection: createBookmarksListSectionContainer(globalConfig),
    klosFooterSection: createKlosFooterSectionContainer(globalConfig),
    footerSection: createFooterSectionContainer(globalConfig),
  };
};
